// crypto.randomUUID is only available in secure contexts (HTTPS or localhost).
// When the dev server is reached over a LAN IP (e.g. http://192.168.x.x), it
// is undefined and any caller throws. This helper falls back to a v4-shaped
// random string in that case.
export function safeUUID(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // RFC4122-ish v4 fallback. Math.random is not cryptographically secure but
  // these IDs are local entity keys, not auth tokens.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
